import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Transfer } from '../transfers/transfer.model';
import { TransferFile } from '../transfers/transfer-file.model';
import { User } from '../users/user.model';
import { HistoryGroup } from './history-group.model';

@Injectable()
export class HistoryService {

  apiHost = environment.apiHost

  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getHistory(page: number, type: string, search?: string, startDate?: string, endDate?: string, status?: string, groupId?: number): Observable<any> {
    let query = "?page="+page+"&type="+type+"&result_size=10&order=desc"
    if (search != null) {query += "&search=" + encodeURIComponent(search)}
    if (startDate != null) {query += "&start_date=" + startDate}
    if (endDate != null) {query += "&end_date=" + endDate}
    if (status != null) {query += "&status=" + status}
    if (groupId != null) {query += "&group_id=" + groupId}

    return this.http.get(this.apiHost+"/history"+query).map(
      (data: any) => {
        let packages = data.packages
        let total = data.total_packages
        if (packages == null) {
          packages = data
          total = 0
        }
        let transfers = packages.map((d) => Transfer.fromPackageRecord(d))
        return {transfers: transfers, total: total};
      }
    ).catch((error) => {
        console.log("Get history error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  addShareUser(user) {
    let path = "/history/share/users/?user_id=" + encodeURIComponent(user.id);
    return this.http.post(this.apiHost+path, {}).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Add share user error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  removeShareUser(user) {
    let path = "/history/share/users/?user_id=" + encodeURIComponent(user.id);
    return this.http.delete(this.apiHost+path).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Remove share user error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  shareUsers() {
    let path = "/history/share/users"
    return this.http.get(this.apiHost+path).map(
      (data: any) => {
        let users = data.users.map((u) => User.fromRecord(u))
        return users;
      }
    ).catch((error) => {
        console.log("Share users error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  groupUsers() {
    let path = "/history/groups/users"
    return this.http.get(this.apiHost+path).map(
      (data: any) => {
        let users = data.users.map((u) => User.fromRecord(u))
        return users;
      }
    ).catch((error) => {
        console.log("Group users error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  groups() {
    let path = "/history/groups"
    return this.http.get(this.apiHost+path).map(
      (data: any) => {
        let groups = data.groups.map((g) => this.parseGroup(g))
        return groups;
      }
    ).catch((error) => {
        console.log("Groups error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  createGroup(group) {
    let path = "/history/groups"
    let payload = {
      group_name: group.name
    }
    return this.http.post(this.apiHost+path, payload).map(
      (data: any) => {
        let group = this.parseGroup(data);
        return group;
      }
    ).catch((error) => {
        console.log("Create group error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  deleteGroup(group) {
    let path = "/history/groups/" + group.id
    return this.http.delete(this.apiHost+path).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Delete group error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  addUserToGroup(user, group) {
    let path = "/history/groups/" + group.id + "/users/?user_id=" + encodeURIComponent(user.id);
    return this.http.post(this.apiHost+path, {}).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Add user to group error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  removeUserFromGroup(user, group) {
    let path = "/history/groups/" + group.id + "/users/?user_id=" + encodeURIComponent(user.id);
    return this.http.delete(this.apiHost+path).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Remove user from group error:", error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  parseGroup(data) {
    return new HistoryGroup({
      id: data["group_id"],
      name: data["group_name"],
      users: data["group_users"].map((u) => User.fromRecord(u))
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/history/history.service.ts